import { Action, ThunkAction } from '../types';
import { captureTaggedException } from '../utilities/analytics/error-reporting';

type MfaPromoteChoice = 'edit_mfa' | 'dismiss' | 'edit_passkey';

const loginPathWithErrorMessage = () => {
  const params = new URLSearchParams({
    errorCode: 'invalid.session.token',
    prompt: 'true',
  }).toString();
  return `${window.location.origin}/login?${params}`;
};

type RedirectOptions = {
  additionalSearchParamsEntries?: Array<[string, string]>;
};

export const handleMfaPromoteUserSelection =
  (
    choice: MfaPromoteChoice,
    queryParams?: string | null,
    redirectOptions?: RedirectOptions
  ): ThunkAction =>
  dispatch => {
    return fetch(`/v2/mfa/promote${queryParams || ''}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ choice }),
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(`${response.status} ${response.statusText}: /v2/mfa/promote`);
        }
      })
      .then(body => {
        if (!body?.redirectTo) {
          captureTaggedException('/v2/mfa/promote did not return a redirectTo', {
            capabilities: ['capability-name--mfa-promote'],
          });
          dispatch(mfaPromoteRedirect(loginPathWithErrorMessage()));
          return;
        }

        const url = new URL(body.redirectTo);

        redirectOptions?.additionalSearchParamsEntries?.forEach(([name, value]) => {
          url.searchParams.append(name, value);
        });

        dispatch(mfaPromoteRedirect(url.toString()));
      })
      .catch(error => {
        captureTaggedException(error, { capabilities: ['capability-name--mfa-promote'] });
        dispatch(mfaPromoteRedirect(loginPathWithErrorMessage()));
      });
  };

export const mfaPromoteRedirect = (redirectTo: string): Action => ({
  type: 'MFA_PROMOTE_REDIRECT',
  redirectTo,
});
